import { Flame } from "lucide-react";
import { SignUpButton } from "@clerk/remix";

export default function BlackFridayBanner() {
  return (
    <div className="bg-orange-500 text-white py-4 px-4 shadow-sm">
      <div className="max-w-5xl mx-auto flex flex-wrap items-center justify-center gap-3 sm:gap-5 text-center sm:text-left">
        <span className="inline-flex items-center gap-2 rounded-full bg-white/20 px-3 py-1 text-xs font-semibold uppercase tracking-[0.2em] text-white">
          <Flame className="h-5 w-5 text-white" />
          Special Offer
        </span>
        <p className="text-base sm:text-lg font-bold tracking-tight">
          Limited-time offer: 40% off Cloud Practitioner prep.
        </p>
        <SignUpButton mode="modal">
          <button className="text-md sm:text-md font-bold text-yellow-200 underline underline-offset-4 hover:text-red-700">
            Lock in the deal
          </button>
        </SignUpButton>
      </div>
    </div>
  );
}
